import { Outlet, Link } from "react-router-dom";
import { LogOut, Building2, UserCog } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";
import { ThemeToggle } from "../../components/ThemeToggle";
import { useEventStream } from "../../hooks/useEventStream";

export function ClienteLayout() {
  const { user, logout } = useAuth();
  useEventStream();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 px-4 sm:px-6 py-3">
        <div className="max-w-5xl mx-auto flex items-center justify-between gap-3">
          <Link to="/cliente" className="flex items-center gap-2 min-w-0">
            <div className="w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center shrink-0">
              <Building2 size={16} className="text-white" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-bold text-slate-800 leading-none truncate">Portal do Cliente</p>
              <p className="text-[11px] text-slate-500">RECDC OS</p>
            </div>
          </Link>
          <div className="flex items-center gap-1 sm:gap-2 shrink-0">
            <Link to="/cliente/perfil" className="text-right hidden sm:block mr-2 hover:text-blue-600">
              <p className="text-sm font-medium text-slate-700 truncate max-w-[160px]">{user?.nome}</p>
              <p className="text-[11px] text-slate-400 truncate max-w-[160px]">{user?.email}</p>
            </Link>
            <Link to="/cliente/perfil" className="sm:hidden p-2 rounded-lg hover:bg-slate-100 text-slate-600" aria-label="Meu perfil">
              <UserCog size={16} />
            </Link>
            <ThemeToggle />
            <button
              onClick={logout}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm text-slate-500 hover:bg-slate-100"
              aria-label="Sair"
            >
              <LogOut size={14} /> <span className="hidden sm:inline">Sair</span>
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-5xl mx-auto p-4 sm:p-6">
        <Outlet />
      </main>
    </div>
  );
}
